// Режим работы с агентом + сохранение выбора между заходами (localStorage).
//   assistant   — Координатор (главный) напрямую.
//   meeting     — «Переговорная»: выбранный субагент напрямую.
//   conference  — «Конференция»: Координатор + команда (как офис).

import { authHeaders, config } from '../config'

export type Mode = 'assistant' | 'meeting' | 'conference'

const MODE_KEY = 'clawapp:mode'
const AGENT_KEY = 'clawapp:meetingAgent'

export function getMode(): Mode {
  try {
    const m = localStorage.getItem(MODE_KEY)
    return m === 'meeting' || m === 'conference' ? m : 'assistant'
  } catch {
    return 'assistant'
  }
}

export function setMode(m: Mode): void {
  try {
    localStorage.setItem(MODE_KEY, m)
  } catch {
    /* noop */
  }
}

export function getMeetingAgent(): string {
  try {
    return localStorage.getItem(AGENT_KEY) || ''
  } catch {
    return ''
  }
}

export function setMeetingAgent(id: string): void {
  try {
    localStorage.setItem(AGENT_KEY, id)
  } catch {
    /* noop */
  }
}

export interface AgentInfo {
  id: string
  name: string
  emoji?: string
  isDefault?: boolean
}

function apiUrl(path: string): string {
  return config.apiBaseUrl ? config.apiBaseUrl + path : path
}

// Запасные имена/иконки (если список ещё не загрузился с сервера).
const FALLBACK: Record<string, { name: string; emoji: string }> = {
  main: { name: 'Координатор', emoji: '🫡' },
  ops: { name: 'Секретарь', emoji: '📋' },
  fitness: { name: 'Coach', emoji: '🏋' },
  lab: { name: 'Разработчик', emoji: '🤓' },
  siam: { name: 'Siam', emoji: '🇹🇭' },
  elvira: { name: 'Эльвира', emoji: '📈' },
  legal_guide: { name: 'Lex', emoji: '🧭' },
}

// Кастом-иконки агентов лежат в public/agents/<id>.png.
const ICON_IDS = new Set(['main', 'ops', 'fitness', 'lab', 'siam', 'elvira', 'legal_guide'])
export function agentIconUrl(id: string | undefined): string | null {
  return id && ICON_IDS.has(id) ? `/agents/${id}.png` : null
}

let agentsCache: AgentInfo[] = []

export async function fetchAgents(): Promise<AgentInfo[]> {
  try {
    const r = await fetch(apiUrl('/api/agents'), { headers: { ...authHeaders() } })
    if (!r.ok) return agentsCache
    const j = await r.json()
    if (Array.isArray(j.agents)) agentsCache = j.agents
    return agentsCache
  } catch {
    return agentsCache
  }
}

/** Идентичность агента по id (имя + иконка) — из кэша или запасной карты. */
export function resolveAgentById(id: string) {
  const realId = id || 'main'
  const fromCache = agentsCache.find((a) => a.id === realId)
  if (fromCache) return { id: realId, name: fromCache.name, emoji: fromCache.emoji || FALLBACK[realId]?.emoji || '' }
  const fb = FALLBACK[realId]
  return { id: realId, name: fb?.name || realId, emoji: fb?.emoji || '' }
}

/** Кто отвечает в данном режиме — для подписи реплики (имя + иконка). */
export function resolveAgent(mode: Mode, meetingAgentId: string) {
  return resolveAgentById((mode === 'meeting' ? meetingAgentId : 'main') || 'main')
}
